/* fabri-archivos.js — Complemento digital en la ficha del kit.
   Si la casilla está marcada, registra el producto digital para que fabri-preadd.js lo
   agregue al carrito justo antes que el kit (una sola vez, aunque se agregue el kit de nuevo). */
(function () {
  if (window.__fabriArchivos) return;
  window.__fabriArchivos = true;

  function scopeOf(el) {
    return el.closest('.shopify-section') || document.body;
  }

  function sync(box) {
    var input = box.querySelector('.fba-input');
    var on = !!(input && input.checked);
    box.classList.toggle('is-on', on);
    scopeOf(box).classList.toggle('fba-activo', on);
  }

  // Marca las secciones que tienen el complemento (respaldo para navegadores sin :has())
  function prepare() {
    document.querySelectorAll('[data-fba]').forEach(function (box) {
      scopeOf(box).classList.add('fba-listo');
      sync(box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare);
  else prepare();

  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest && e.target.closest('[data-fba]');
    if (box) sync(box);
  });

  // Al volver con "atrás" el navegador puede restaurar la casilla marcada
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-fba]').forEach(sync);
  });

  window.FabriPreAdd = window.FabriPreAdd || [];
  window.FabriPreAdd.push(function (form, scope) {
    var box = scope.querySelector('[data-fba]');
    var input = box && box.querySelector('.fba-input');
    if (!input || !input.checked) return [];
    return [{ id: box.dataset.variant, quantity: 1, unico: true }];
  });
})();
